import { render, staticRenderFns } from "./CoolMathRotatePhone.vue?vue&type=template&id=653d5654&scoped=true&"
var script = {}
import style0 from "./CoolMathRotatePhone.vue?vue&type=style&index=0&id=653d5654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d5654",
  null
  
)

export default component.exports